exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "page-layout-simple {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 100%;\n  width: 100%;\n  min-height: 0;\n}\n.flex-tall {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n", ""]);

